import DfpRequestBuilder from 'utils/dfp-request-builder';
import { filter } from 'rxjs/operators';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _isNil from 'lodash/isNil';

/**
 *
 * @desc PlayerUtils utility
 *
 */
class PlayerUtils {

    constructor() {

        this.embedWrapper = null;

    }

    static getEmbedWrapper() {

        return this.embedWrapper;

    }

    static isPrerollAdEnabled(mediaConfig) {

        return _get(mediaConfig, 'videocore.advertising.dfp.enabled');

    }

    static onPlayerLoadedHandler(embedWrapper, clipData, onNextClipDataLoaded, onAdStartedEvent) {

        const subscriptions = [];

        if(!embedWrapper) {

            return subscriptions;

        }

        this.embedWrapper = embedWrapper;

        return embedWrapper.getObservationCenter().then((observationCenter) => {

            subscriptions.push(
                observationCenter.embedSubject.pipe(filter((event) => {

                    return event.type === 'metaDataLoaded';

                })).subscribe((message) => {

                    const nextClipData = _get(message, 'data.data');

                    this.metaDataLoaded(clipData, nextClipData, onNextClipDataLoaded);

                })
            );

            subscriptions.push(
                observationCenter.pluginSubject.pipe(filter((event) => {

                    return event.type === 'adStartedEvent';

                })).subscribe((message) => {

                    const adConfig = _get(message, 'config.dfp');
                    const adEvent = _get(message, 'adEvent');
                    const ad = adEvent && adEvent.getAd();

                    this.adStartedEvent(adConfig, ad, onAdStartedEvent);

                })
            );

            return subscriptions;

        });

    };

    static adStartedEvent(adConfig, ad, onAdStartedEvent) {

        if (
            _isNil(adConfig)
            || _isNil(ad)
            || typeof onAdStartedEvent !== 'function'
        ) {

            return false;

        }

        return onAdStartedEvent(adConfig, ad);

    }

    static metaDataLoaded(prevClipData, nextClipData, onNextClipDataLoaded) {

        const prevClipDataId = _get(prevClipData, 'id');
        const nextClipDataId = _get(nextClipData, 'id');

        if (
            _isNil(nextClipData)
            || typeof onNextClipDataLoaded !== 'function'
            || prevClipDataId === nextClipDataId
        ) {

            return false;

        }

        return onNextClipDataLoaded(nextClipData);

    };

    static customAdRequestBuilder(config, clip, cuePointVO, isLargeBp, isClubPage, topicId, mbox) {

        if(_isNil(config)) {

            return null;

        }
        
        const pageAdConfig = isClubPage ? _get(config, 'team') : _get(config, 'vpp');
        const pageCustParams = {
            ..._get(pageAdConfig, 'cust_params'),
            ...{},
        };


        if(pageCustParams && Object.keys(pageCustParams).length > 0) {

            const pageCustParamsPageId = _get(pageCustParams, 'pageid');
            let adobeKeyVal;

            if(topicId && pageCustParamsPageId) {

                _set(pageCustParams, 'pageid', pageCustParamsPageId.replace('{topic_id}', topicId));

            }

            if(mbox) {
                
                Object.keys(mbox).forEach(mKey => {
                    _set(pageCustParams, mKey , mbox[mKey]);
                });
            
            }

            _set(config, 'cust_params', pageCustParams);

        }
    
        _set(config, 'ciu_szs', isLargeBp ? '300x250' : '320x50');
        _set(config, 'topicId', topicId);

        return DfpRequestBuilder.build(config, clip, cuePointVO);

    };

    static unsubscribeFromSubscriptions(subscriptions) {

        if(!Array.isArray(subscriptions)) {

            return [];

        }

        const destroyedSubscriptions = [];

        subscriptions.forEach((subscription) => {

            if(subscription.unsubscribe) {

                subscription.unsubscribe();
                destroyedSubscriptions.push(subscription);

            }

        });

        return destroyedSubscriptions;

    };

    static getDeviceInfo() {
        if(typeof window.deviceBootstrap !== 'function' ) {
            return undefined;
        }
        const currentDevice = window.deviceBootstrap();

        return {
            userAgent: _get(currentDevice, 'userAgent'),
            formFactor: _get(currentDevice, 'formFactor', 'desktop'),
            details: _get(currentDevice, 'is'),
            browser: _get(currentDevice, 'browser'),
        };
    };

};

export default PlayerUtils;
